webinarAttendeeQuestionSubmitControl.directive('webinarAttendeeQuestionSubmitControl', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                helperService.getRedesignPathPrefix() + 'webinarAttendeeQuestionSubmitControl.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
